var _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#E65C6C",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M60.8 35.1998C61.1779 35.572 61.4781 36.0156 61.6829 36.5049C61.8878 36.9942 61.9933 37.5193 61.9933 38.0498C61.9933 38.5802 61.8878 39.1053 61.6829 39.5946C61.4781 40.0839 61.1779 40.5276 60.8 40.8998L53.68 47.9998C52.9268 48.753 51.9052 49.1761 50.84 49.1761C49.7748 49.1761 48.7532 48.753 48 47.9998C47.2468 47.2465 46.8236 46.225 46.8236 45.1598C46.8236 44.0946 47.2468 43.073 48 42.3198L55.1 35.1998C55.4722 34.8218 55.9158 34.5217 56.4051 34.3168C56.8944 34.112 57.4195 34.0064 57.95 34.0064C58.4804 34.0064 59.0056 34.112 59.4949 34.3168C59.9841 34.5217 60.4278 34.8218 60.8 35.1998ZM65.06 30.9398C64.13 29.9995 63.0227 29.253 61.8023 28.7435C60.5819 28.234 59.2725 27.9717 57.95 27.9717C56.6275 27.9717 55.3181 28.234 54.0977 28.7435C52.8772 29.253 51.77 29.9995 50.84 30.9398L43.74 37.9998C41.857 39.8828 40.7991 42.4367 40.7991 45.0998C40.7991 46.4184 41.0588 47.724 41.5634 48.9423C42.068 50.1605 42.8076 51.2674 43.74 52.1998C44.6724 53.1321 45.7793 53.8718 46.9975 54.3764C48.2157 54.881 49.5214 55.1407 50.84 55.1407C53.503 55.1407 56.0569 54.0828 57.94 52.1998L65.06 45.0998C66.0003 44.1698 66.7468 43.0625 67.2563 41.8421C67.7657 40.6216 68.0281 39.3123 68.0281 37.9898C68.0281 36.6672 67.7657 35.3579 67.2563 34.1374C66.7468 32.917 66.0003 31.8097 65.06 30.8798V30.9398Z",
    fill: "url(#paint0_linear_550_17136)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2599 43.74C51.289 42.7531 50.1153 41.9888 48.8199 41.5L47.9999 42.32C47.625 42.6919 47.3274 43.1343 47.1244 43.6217C46.9213 44.1091 46.8167 44.632 46.8167 45.16C46.8167 45.688 46.9213 46.2109 47.1244 46.6983C47.3274 47.1857 47.625 47.6281 47.9999 48C48.3748 48.3719 48.6724 48.8143 48.8755 49.3017C49.0786 49.7891 49.1831 50.312 49.1831 50.84C49.1831 51.368 49.0786 51.8909 48.8755 52.3783C48.6724 52.8657 48.3748 53.3081 47.9999 53.68L40.8999 60.8C40.1441 61.5559 39.1189 61.9805 38.0499 61.9805C36.981 61.9805 35.9558 61.5559 35.1999 60.8C34.4441 60.0441 34.0194 59.019 34.0194 57.95C34.0194 56.881 34.4441 55.8559 35.1999 55.1L41.4999 48.82C40.5748 46.4677 40.5748 43.8523 41.4999 41.5C40.1831 41.981 38.9882 42.7457 37.9999 43.74L30.9399 50.84C29.0542 52.7257 27.9949 55.2832 27.9949 57.95C27.9949 60.6168 29.0542 63.1743 30.9399 65.06C32.8256 66.9457 35.3832 68.0051 38.0499 68.0051C40.7167 68.0051 43.2742 66.9457 45.1599 65.06L52.2599 58C53.2063 57.0693 53.9579 55.9596 54.471 54.7355C54.9841 53.5113 55.2483 52.1973 55.2483 50.87C55.2483 49.5427 54.9841 48.2287 54.471 47.0045C53.9579 45.7804 53.2063 44.6707 52.2599 43.74Z",
    fill: "url(#paint1_linear_550_17136)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_550_17136",
    x1: 40.7991,
    y1: 41.5562,
    x2: 68.0281,
    y2: 41.5562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65CA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_550_17136",
    x1: 27.9949,
    y1: 54.7525,
    x2: 55.2483,
    y2: 54.7525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65CA7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLinkIcon);
export default __webpack_public_path__ + "static/media/add-link-icon.c85b054f94d55f6bb1aea52d0af52e17.svg";
export { ForwardRef as ReactComponent };